import axiosInstance from './apiConfig';
import { chatHistoryUrl, LoginUrl, QueryFeedBackUrl, UserFeedBackUrl, UserSessionUrl } from './endpoints';


// employeeId, password
export const loginRequest = async (data: { emp_n: string; pass: string }) => {
  const { emp_n, pass } = data;

  const request = {
    url: LoginUrl,
    method: 'POST',
    data: {
      emp_n,
      pass,
      // plateform: 'NiveusChatbot', 
    },
  };

  try {
    const response = await axiosInstance(request);
    return response.data;
  } catch (error) {
    console.error('Login error', error);
    throw error;
  }
};


export const CreateSessionRequest = async (data: {
  emp_No: string;
  phone_number: string;
  division_code: string;
  division_name: any;
  location: string;
  name: string;
  email: string;
  role: string;
}) => {

  const { emp_No, phone_number, division_code, division_name, location, name, email, role } = data;

  const request = {
    url: UserSessionUrl,
    method: 'POST',
    data: {
      emp_No,
      phone_number,
      division_code,
      division_name,
      location,
      name,
      email,
      role
    }
  };

  try {
    const response = await axiosInstance(request);
    return response;
  } catch (error) {
    console.error('CreateSessionRequest', error);
    throw error;
  }
};

export const UserFeedBackRatings = async (data: { chatRating: string; recommendRating: string }) => {
  const { chatRating, recommendRating } = data;
  const lastResponseId = sessionStorage?.getItem('LastResponseId');

  const request = {
    url: `${UserFeedBackUrl}${lastResponseId}`,
    method: 'PATCH',
    data: {
      chatRating,
      recommendRating,
    },
  };

  try {
    const response = await axiosInstance(request);
    return response;
  } catch (error) {
    console.error('UserFeedBackRatings', error);
    throw error;
  }
};

export const QueryFeedback = async (data: { chatId: string; thumpup: string }) => {
  const { chatId, thumpup } = data;
  const id = chatId.toString();

  const request = {
    url: `${QueryFeedBackUrl}${id}`,
    method: 'PATCH',
    data: {
      thumpup,
    }
  };

  try {
    const response = await axiosInstance(request);
    return response;
  } catch (error) {
    console.error('QueryFeedback', error);
    throw error;
  }
};

export const ChatHistory = async () => {
  const userId = sessionStorage?.getItem('userId');;

  const request = {
    url: `${chatHistoryUrl}${userId}`,
    method: 'GET',
  };

  try {
    const response = await axiosInstance(request);
    return response;
  } catch (error) {
    console.error('chat histroy', error);
    throw error;
  }
};
